import BaseModel from './base-model.js'
import { useSettings } from '@store/settings'
const $settings = useSettings()

class Appointment extends BaseModel {
    /**
     * Set the title of the model
     */
    title = $settings.labels.appointment?.singular

    /**
     * Set the id of the model
     */
    route = 'appointment'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = 'appointment_id'
}

export default Appointment